import { i18nMark } from 'lingui-react';

const messages = {
  logout: i18nMark('Log Out'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/TopNav/UserProfile/messages.js